import { useData } from "../hooks/useData";
import Http from "../fetch";
import { API__Heatmap, HeatmapPoint } from "../models/Heatmap";
import { ID } from "../models";

export function toHeatmapPoints(response: API__Heatmap[]): HeatmapPoint[] {
    return response.map(item => [+item.ln, +item.lt] as HeatmapPoint);
}

async function getHeatmapData(chainId: ID): Promise<HeatmapPoint[]> {
    const response: API__Heatmap[] = await Http.post(
        "chain map",
        {},
        {
            body: JSON.stringify({ chainId }),
            headers: {
                "content-type": "application/json; charset=utf-8",
            },
        },
    );

    return toHeatmapPoints(response);
}

export default function useHeatmapData(chainId: ID) {
    return useData<HeatmapPoint[]>([], getHeatmapData, chainId);
}
